import React, { useEffect } from 'react';
import SEO from '../../Components/SEO/SEO';
import MobileRechargeContext from '../../Context/MobileRechargeContext';
import GrowYourBussion from '../../Components/GrowYourBussion/GrowYourBussion';
import AboutPay2Mobile from '../../Components/AboutPay2Mobile';
import DownloadPay2Mobile from '../..//Components/DownloadPay2Mobile';
import FooterContent from '../../Components/Footer/footer-content';
import { Wrapper } from '../../Components/Navigation/style';
import BBPS from '../../Components/BBPS/BBPS';
import { ServiceBoxWrapper } from '../../Components/ServicesBox/style';
import bbpsLogo2 from '../../assets/images/BBPS3.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { isEmpty } from '../../utils/common';
import Back from '../../Components/UIbox/Back';

function BBPSPayments() {
	const { state } = useLocation();

	const navigate = useNavigate();
	useEffect(() => {
		if (isEmpty(state)) {
			navigate('/bbps-services');
			return;
		}
	}, []);

	console.log("state",state)

	return (
		<>
			<SEO
				title="Secure Payments for AEPS, DMT, Bill Payments & Recharges | Pay2Mobiles"
				description="Make secure and fast payments with Pay2Mobiles. Simplify your AEPS, DMT, bill payments, and recharge transactions using our reliable and user-friendly payment platform"
				keywords="Payment Page, Secure Payments, AEPS Payments, DMT Transactions, Bill Payment Platform, Recharge Payments, Digital Payments, Pay2Mobiles Transactions, Online Payment Gateway, Fast and Secure Transactions"
			/>
			<div className="container">
				<div className="Home-page">
					<Wrapper className="box">
						<ServiceBoxWrapper style={{ minHeight: 'auto' }}>
							<div className="header flex justify-between items-center">
								<div className="flex gap-10">
									<Back url="/bbps-services" />
									{/* <h2 className="m0">{state?.label}</h2> */}
								</div>
								<div className="logo"> <img src={bbpsLogo2} alt="bbps logo" /> </div>
							</div>
						</ServiceBoxWrapper>
					</Wrapper>
					<BBPS className="electricity-form" />
				</div>
			</div>
			<AboutPay2Mobile />
			<FooterContent />
			<GrowYourBussion />
			<DownloadPay2Mobile />
		</>
	);
}

export default BBPSPayments;
